import { useEffect, useMemo } from "react";
import { useAppDispatch } from "store/hooks";
import logger from "logging/logger";
import { useSelector } from "react-redux";
import { setCurrentAudio } from "modules/audioReactions/redux/slice";
import { selectCurrentAudio } from "modules/audioReactions/redux/selectors";

export const PlaySoundHandler = () => {
  const dispatch = useAppDispatch();
  const currentAudio = useSelector(selectCurrentAudio);

  const sound = useMemo(() => {
    if (!currentAudio) return null;

    return new Audio(currentAudio);
  }, [currentAudio]);

  useEffect(() => {
    if (!sound) {
      return undefined;
    }

    const handleAudioStopped = () => {
      dispatch(setCurrentAudio(undefined));
    };

    sound.addEventListener("ended", handleAudioStopped);

    return () => {
      sound.removeEventListener("ended", handleAudioStopped);
    };
  }, [sound, dispatch]);

  useEffect(() => {
    const playSound = async () => {
      if (!sound) {
        return;
      }

      try {
        await sound.play();
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : "";
        logger.error(`[playSound] error: ${errorMessage}`);
      }
    };

    if (sound && currentAudio) {
      playSound();
    }
  }, [sound, currentAudio]);

  return null;
};
